// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".airlineList {\n  margin-left: 20px;\n  list-style-type: disc;\n}\n.airlineList li {\n  margin-bottom: 5px;\n}\n.tableScroll {\n  overflow-x: auto;\n}\n.baggageTable {\n  border-collapse: collapse;\n  margin-top: 10px;\n  width: 100%;\n}\n.baggageTable td,\n.baggageTable th {\n  border: 1px solid #ddd;\n  padding: 5px;\n}\n.baggageTable th {\n  background-color: #f2f2f2;\n}\n.commenceRow {\n  text-align: center;\n  background-color: #fafafa;\n  font-weight: 500;\n}\n", ""]);
// Exports
module.exports = exports;
